<template>
  <div class="product-page">
    <Header type="black" />
    
    <div v-if="loading" class="loading-screen" style="min-height: 80vh; display: flex; align-items: center; justify-content: center; background-color: #131619;">
      <h2 style="color: white;">Yükleniyor...</h2>
    </div>

    <div v-else-if="!product" class="error-screen" style="min-height: 80vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: #131619;">
      <h2 style="color: #ff6b6b; margin-bottom: 20px;">Bu ürün veritabanında bulunamadı!</h2>
      <p style="color: #ccc; margin-bottom: 30px;">Lütfen Admin paneli üzerinden ürünün eklendiğinden emin olun.</p>
      <div style="width: 200px;">
        <router-link :to="`/${$route.params.locale || 'tr'}/products`" style="text-decoration: none;">
          <Button type="transparent" href="#" text="Ürünlere Dön" :link="null" target="_self" />
        </router-link>
      </div>
    </div>

    <div v-else class="_container">
      <div style="width: 150px; color: white; padding-top: 3%; margin-left: 5%;">
          <router-link :to="`/${$route.params.locale || 'tr'}/products`" style="text-decoration: none;">
            <Button type="transparent" href="#" :text="$t('button.back')" :link="null" target="_self" />
          </router-link>
      </div>
      
      <div class="introContainer">
          <div class="introColImg">
              <img class="introImg" v-if="product.heroImage" :src="product.heroImage" :alt="product.title">
          </div>
          <div class="introColText">
              <h1 class="introTitle">
                  {{ product.detailTitle || product.title }}
              </h1>
              <p class="introSubtitle">
                 {{ product.detailDesc }}
              </p>
          </div>
      </div>

      <div class="technicalContainer" v-if="formattedSpecs.length > 0 || product.wireframeImage">
          <div class="technicalColText">
              <h1 class="technicalTitle">Teknik Özellikler</h1>
              <div class="technicalSubtitle">
                  <ul class="technicalList">
                      <li v-for="(spec, index) in formattedSpecs" :key="index">{{ spec }}</li>
                  </ul>
              </div>
          </div>
          <div class="technicalColImg" v-if="product.wireframeImage">
              <img class="technicalImg" :src="product.wireframeImage" :alt="product.title + ' Wireframe'">
          </div>
      </div>

      <h1 class="partHead" v-if="product.part1Title || product.part2Title || product.part3Title">
            Teknik Parçalar
      </h1>
      
      <div class="partContainer" style="margin-bottom: 100px;">
          <div class="partImg" v-if="product.part1Title || product.part1Image">
              <img v-if="product.part1Image" :src="product.part1Image" :alt="product.part1Title">
              <h2 class="partTitle">{{ product.part1Title }}</h2>
          </div>
          <div class="vl" v-if="product.part2Title"></div>
          <div class="partImg" v-if="product.part2Title || product.part2Image">
              <img v-if="product.part2Image" :src="product.part2Image" :alt="product.part2Title">
              <h2 class="partTitle">{{ product.part2Title }}</h2>
          </div>
          <div class="vl" v-if="product.part3Title"></div>
          <div class="partImg" v-if="product.part3Title || product.part3Image">
              <img v-if="product.part3Image" :src="product.part3Image" :alt="product.part3Title">
              <h2 class="partTitle">{{ product.part3Title }}</h2>
          </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import AOS from 'aos';
import Header from '../components/common/Header.vue';
import Footer from '../components/common/Footer.vue';
import Button from '../components/common/Button.vue';
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app", 
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

const route = useRoute();
const product = ref(null);
const loading = ref(true);

const formattedSpecs = computed(() => {
  if (!product.value || !product.value.techSpecs) return [];
  return product.value.techSpecs.split('\n').filter(spec => spec.trim() !== '');
});

onMounted(async () => {
  AOS.init({once: false});
  try {
    const productId = route.params.id; 
    
    if (!productId || productId === 'undefined') {
      loading.value = false;
      return;
    }

    const docRef = doc(db, "urunler", productId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      product.value = docSnap.data();
      document.title = (product.value.title || 'Ürün Detayı') + ' | BAU Innovation';
    } else {
      console.log("Veritabanında böyle bir ürün ID'si yok:", productId);
    }
  } catch (error) {
    console.error("Firebase çekme hatası:", error);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
._container { background-color: #131619; font-family: 'DM Sans', sans-serif; min-height: 100vh; }
.introContainer { display: flex; flex-direction: row; justify-content: center; align-items: center; margin-bottom: 100px; padding-top: 50px; }
.introColImg { display: flex; justify-content: center; align-items: center; width: 60%; overflow: hidden; }
.introImg { width: 100%; height: 50%; min-height: 450px; object-fit: cover; }
.introColText { display: flex; width: 35%; flex-direction: column; }
.introColText .introTitle { font-family: 'DM Sans', sans-serif; color: aliceblue; font-size: 36px; margin-bottom: 20px; }
.introSubtitle { font-family: 'DM Sans', sans-serif; color: rgb(169, 167, 167); font-size: 18px; line-height: 30px; white-space: pre-wrap; }
.partContainer { display: flex; flex-direction: row; justify-content: space-between; }
.vl { border-left: 1px dotted rgba(255, 255, 255, 0.5); }
.partHead { color: aliceblue; font-family: 'DM Sans', sans-serif; font-size: 40px; width: 100%; height: 60px; display: flex; justify-content: center; margin-bottom: 80px; }
.partImg { display: flex; flex-direction: column; justify-content: center; align-items: center; width: 33%; transition: transform 250ms ease-in-out; }
.partImg img { height: 300px; object-fit: contain; }
.partTitle { color: rgb(169, 167, 167); margin-top: 30px; margin-bottom: 100px; text-align: center; }
.partImg:hover { transform: translateY(-30px); }
@media screen and (max-width: 1023px) {
  .introContainer { flex-direction: column; padding: 5%; margin-bottom: 20px; }
  .introColImg { width: 100%; }
  .introColText { width: 100%; }
  .partContainer { flex-direction: column; }
  .partImg { width: 100%; margin-bottom: 40px; }
  .partImg img { width: 35%; height: auto; min-width: 300px; }
  .partTitle { margin-bottom: 20px; }
}
.technicalContainer { display: flex; justify-content: space-around; flex-direction: row; margin-bottom: 100px; }
.technicalColImg { display: flex; justify-content: center; align-items: center; width: 20%; overflow: hidden; }
.technicalColText { display: flex; flex-direction: column; padding: 5%; }
.technicalColText .technicalTitle { font-family: 'DM Sans', sans-serif; color: aliceblue; font-size: 36px; margin-bottom: 20px; }
.technicalList { font-family: 'DM Sans', sans-serif; color: rgb(169, 167, 167); font-size: 18px; line-height: 30px; }
@media screen and (max-width: 1023px) {
  .technicalContainer { flex-direction: column; justify-content: center; display: flex; align-items: center; }
  .technicalColImg { width: 50%; }
  .technicalColList { width: 100%; }
}
</style>